const VISIBLE_START = 14;
const VISIBLE_END = 3;
const ELLIPSIS = '...';

/** Masks any credential string: `ck_live_abc123...xyz`. Short values are returned untouched. */
export function maskValue(value: string, visibleStart = VISIBLE_START, visibleEnd = VISIBLE_END): string {
  if (value.length <= visibleStart + visibleEnd + ELLIPSIS.length) return value;
  return `${value.slice(0, visibleStart)}${ELLIPSIS}${value.slice(-visibleEnd)}`;
}
